<template>
  <span class="inputFile">
    <label for="file-upload" class="custom-file-upload" @click="resetInfos()">
      <v-icon>{{prevIcon}}</v-icon>
      {{text}}
    </label>
    <small :class="color">
      {{fileText}}
      <span class="teal_bold">{{path}}</span>
    </small>
    <input
      type="file"
      @change="setFile($event)"
      name="file-upload"
      value="file"
      @keypress.enter.prevent
      @keydown.enter.prevent
      id="file-upload"
      :accept="this.component == 'certificado' ? '.pfx' : this.component == 'imagem' ? 'image/jpg' : this.component == 'xml' ? '.xml' : ''"
      :multiple="this.component == 'xml' || this.component == 'pdf' ? true : false"
    />
    <br />
    <small class="typeArquivo">
      Formato aceito:
      <strong class="teal--text text--darken-4">
        <span v-if="component == 'certificado'">.pfx</span>
        <span v-else-if="component == 'xml'">.xml</span>
        <span v-else-if="component == 'pdf'">.pdf</span>
        <span v-else-if="component == 'imagem'">.jpg .jpeg</span>
      </strong>
    </small>
    <br />
    <small v-if="component == 'imagem'" class="typeArquivo">
      Tamanho máximo do arquivo:
      <strong class="teal--text text--darken-4">
        <span>{{tamMaximo/1000000}} MB</span>
      </strong>
    </small>
    <br />
  </span>
</template>

<script>
export default {
  props: ["text", "prevIcon", "resetInput", "component"],
  data: () => ({
    color: null,
    fileText: "Nenhum arquivo selecionado",
    path: "",
    //tamanho em bites.
    //cada 1000000 bites equivale à um mb
    tamMaximo: 2500000
  }),
  mounted: function() {
    this.$nextTick(function() {});
  },
  watch: {
    resetInput: function(newV, oldV) {
      if (newV) {
        this.resetInfos();
      }
    }
  },
  methods: {
    resetInfos() {
      let file = document.querySelector("#file-upload");
      file.value = "";

      this.path = "";
      this.fileText = "Nenhum arquivo selecionado";
      this.$emit("emitResetInput", false);
    },
    setFile: function(e) {
      this.path = "";
      this.color = null;
      if (e.target.type == "file") {
        if (e.target.files.length > 0) {
          if (this.component == "imagem") {
            if (e.target.files[0].type != "image/jpeg") {
              this.fileText = "Formato de arquivo inválido";
              this.color = "red--text text--darken-4";
              return;
            } else if (e.target.files[0].size > this.tamMaximo) {
              this.fileText = "Arquivo muito grande";
              this.color = "red--text text--darken-4";
              return;
            } else {
              this.fileText = "Arquivo selecionado: ";
              this.path = e.target.files[0].name;
              this.$emit("getFile", e.target.files);
            }
          } else if (
            this.component == "certificado" &&
            e.target.files[0].type != "application/x-pkcs12"
          ) {
            this.fileText = "Formato de arquivo inválido";
            this.color = "red--text text--darken-4";
          } else if (this.component == "xml") {
            let arqValidos = [];
            let arqInvalidos = [];
            let path = "";
            let invPath = "";
            for (let i = 0; i < e.target.files.length; i++) {
              let elem = e.target.files[i];
              if (elem.type != "text/xml") {
                invPath += `"${elem.name}" `;
                arqInvalidos.push(elem);
              } else {
                path += `"${elem.name}" `;
                arqValidos.push(elem);
              }
            }
            if (arqInvalidos.length > 0) {
              this.fileText = "Formato de arquivo inválido em: " + invPath;
              this.color = "red--text text--darken-4";
            } else {
              this.fileText =
                e.target.files.length == 1
                  ? "Arquivo selecionado: "
                  : "Arquivos selecionados";
              this.path = path;
              this.fileText = "";
              this.path = "";
            }
            this.$emit("getFile", arqValidos);
            let file = document.querySelector("#file-upload");
            file.value = "";
          } else if (this.component == "pdf") {
            let arqValidos = [];
            let arqInvalidos = [];
            let path = "";
            let invPath = "";
            for (let i = 0; i < e.target.files.length; i++) {
              let elem = e.target.files[i];
              if (elem.type != "application/pdf") {
                invPath += `"${elem.name}" `;
                arqInvalidos.push(elem);
              } else {
                path += `"${elem.name}" `;
                arqValidos.push(elem);
              }
            }
            if (arqInvalidos.length > 0) {
              this.fileText = "Formato de arquivo inválido em: " + invPath;
              this.color = "red--text text--darken-4";
            } else {
              this.fileText =
                e.target.files.length == 1
                  ? "Arquivo selecionado: "
                  : "Arquivos selecionados";
              this.path = path;
              this.fileText = "";
              this.path = "";
            }
            this.$emit("getFile", arqValidos);
            let file = document.querySelector("#file-upload");
            file.value = "";
          } else {
            this.fileText = "Arquivo selecionado: ";
            this.path = e.target.files[0].name;
            this.$emit("getFile", e.target.files);
          }
        } else {
          this.fileText = "Nenhum arquivo selecionado";
          this.$emit("getFile", undefined);
        }
      }
    }
  }
};
</script>
<style scoped>
i {
  font-size: 18px;
}
.inputFile {
  display: inline-block;
}
.inputFile input[type="file"] {
  display: none;
}
.inputFile .custom-file-upload {
  border-radius: 11px;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
small.typeArquivo {
  color: grey;
  font-weight: 700;
  margin-left: 5px;
}
.teal_bold {
  color: teal;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputFile/InputFile.vue